import { useContext } from 'react';
import classNames from 'classnames';
import { Button, MFLink } from '@medifind/shared-basic-components';
import { getSmallClassList } from '@medifind/utils';
import { CardContext } from './Card';
import styles from './CardActionButton.module.scss';

const CardActionButton = ({
  to,
  absoluteUrl,
  buttonType = 'normal',
  onClick,
  disabled,
  noWrapping = true,
  analyticsLinkType,
  color = 'blue',
  classes,
  wideCard = false,
  rel,
  ...props
}) => {
  const { smallAt } = useContext(CardContext);
  const { smallClassList } = getSmallClassList(smallAt, styles);
  return (
    <MFLink
      analyticsLinkType={analyticsLinkType}
      target={absoluteUrl ? '_blank' : undefined}
      to={to}
      onClick={onClick ? onClick : null}
      disabled={disabled}
      noTabIndex
      className={classNames(
        styles['card-action-button-link'],
        smallClassList,
        classes?.link,
        wideCard ? styles['card-action-button-link__wide'] : '',
      )}
      rel={rel}
    >
      <Button
        classes={{
          ...classes,
          container: classNames(
            styles['card-action-button-container'],
            classes?.container,
            smallClassList,
            wideCard ? styles['card-action-button-link__wide'] : '',
          ),
        }}
        color={color}
        disabled={disabled}
        type={buttonType}
        showSkeleton={disabled}
        noWrapping={noWrapping}
        {...props}
      />
    </MFLink>
  );
};

export { CardActionButton as default, CardActionButton };
